import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import Dialog from '/@/components/dialog';
import { _ } from '/@/locale';

@autobind
export default class ErrorDialog extends Component {
    static propTypes = {
        type: PropTypes.string,
        visible: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
        onCancel: PropTypes.func,
        onAccept: PropTypes.func,
    };

    getMessage() {
        switch (this.props.type) {
            case 'zone':
                return _('La ubicación marcada no está dentro de una zona agronómica reconocida por la aplicación.');
            case 'country':
                return _('La ubicación marcada no pertenece al país activo. Querés cambiar el país para continuar?');
            case 'geocode':
                return _('Hubo un error al realizar la geolocalización.');
            default:
                return _('Ha ocurrido un error...');
        }
    }

    render() {
        return (
            <Dialog
                visible={this.props.visible}
                title={this.props.type === 'country' ? _('Cambiar de país') : ''}
                message={this.getMessage()}
                acceptLabel={this.props.type === 'country' ? _('Cambiar y crear lote') : undefined}
                onClose={this.props.onClose}
                onCancel={this.props.type === 'country' ? this.props.onCancel : undefined}
                onAccept={this.props.onAccept}
            />
        );
    }
}
